module.exports = {"430423100":"开云镇","430423101":"白果镇","430423102":"东湖镇","430423103":"萱洲镇","430423104":"长江镇","430423105":"新桥镇","430423107":"店门镇","430423201":"永和乡","430423203":"福田铺乡","430423204":"岭坡乡","430423207":"贯塘乡","430423208":"江东乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430423.json
// module id = 1964
// module chunks = 0